import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { defaultContainerSize, mq } from '../../../styles/mixins';
import { Headline1, ParagraphS } from '../../core/Typography/Typography';

export const Wrapper = styled.section`
  position: relative;
  overflow-x: hidden;
  ${defaultContainerSize};
  margin: 0;
  max-width: 100%;
  background: ${({ theme }) => theme.colors.core_black};
  padding-top: 4rem;
  padding-bottom: 18.3125rem;

  ${mq.xLarge(css`
    padding-bottom: 15.4375rem;
    padding-top: 6.5625rem;
  `)};
`;

export const GoalsInner = styled.div`
  width: 100%;
  max-width: 77.125rem;
  margin: 0 auto;
  display: flex;
  flex-direction: column;

  ${mq.large(css`
    justify-content: space-between;
    flex-direction: row;
  `)};
`;

export const GoalsTextWrapper = styled.div`
  order: 1;

  ${mq.large(css`
    order: 1;
    width: 60%;
  `)};

  ${mq.xLarge(css`
    width: 50%;
  `)};
`;

export const GoalsImageWrapper = styled.div`
  order: 1;
  margin-bottom: 2rem;
  height: 100%;
  width: 100%;
  max-width: 29.25rem;
  max-height: 27.5rem;
  align-self: flex-end;

  ${mq.large(css`
    order: 2;
    max-width: 29.25rem;
    margin-bottom: -4em;
    align-self: unset;
  `)};

  ${mq.xLarge(css`
    order: 2;
    width: 50%;
    margin-bottom: 0;
  `)};

  img {
    width: 100%;
    height: 100%;
  }
`;

export const GoalsTitle = styled.h3`
  ${Headline1};
  margin: 0 0 2rem 0;

  ${mq.large(css`
    max-width: 35.625rem;
  `)};

  ${mq.xLarge(css`
    letter-spacing: -0.0125rem;
  `)};
`;

export const GoalsTitlePrimary = styled.span`
  color: ${({ theme }) => theme.colors.primary};
`;

export const GoalsTitleWhite = styled.span`
  color: ${({ theme }) => theme.colors.core_white};
`;

export const GoalsPoint = styled.p`
  ${ParagraphS};
  max-width: 31.5625rem;
  display: flex;
  flex-direction: row;
  letter-spacing: 0.0125rem;
  color: ${({ theme }) => theme.colors.core_white};
  margin: 0 0 2rem 0;

  &:not(:last-child) {
    margin: 0 0 2rem 0;
  }

  ${mq.large(css`
    max-width: 31.5625rem;
  `)};
`;

export const GoalsPointCheckmark = styled.span`
  margin-right: 1.5rem;

  ${mq.xLarge(css`
    margin-right: 2.5rem;
  `)};
`;
